import React from "react";
import Nav from "../Nav"
import Footer from "../Footer"
import UserPageBody from "../UserPageBody";

export default function UsersPage(){

    return(
        <div>
            <Nav/>
          <UserPageBody/>
            <Footer/>


        </div>


    );




}